import React from 'react';
import { Tooltip } from 'antd';

/**
 * 2-line ellipsis with full text in tooltip. Keeps card rows visually aligned.
 * @param {'p'|'h4'|'h3'|'span'|'div'} as
 * @param {string} text - must be a string (plain text for tooltip and display)
 * @param {string} [className]
 * @param {import('react').MouseEvent} [onClick]
 */
export default function HomeClampedText({
  as: Tag = 'p',
  text,
  className = '',
  omitBaseClass = false,
  overlayClassName = 'home-clamped-text-tooltip',
  onClick,
  ...rest
}) {
  if (text == null) {
    return null;
  }
  const s = String(text);
  if (!s.trim()) {
    return null;
  }
  const cls = [omitBaseClass ? '' : 'home-card-text-clamp', className].filter(Boolean).join(' ').trim();
  return (
    <Tooltip
      title={s}
      placement="top"
      mouseEnterDelay={0.3}
      overlayClassName={overlayClassName}
      getPopupContainer={(n) => n?.parentElement || document.body}
    >
      <Tag
        className={cls}
        onClick={onClick}
        role={onClick ? 'button' : undefined}
        {...rest}
      >
        {s}
      </Tag>
    </Tooltip>
  );
}
